const LazyLoad = require("vanilla-lazyload");
if ('loading' in HTMLImageElement.prototype) {
    const images = document.querySelectorAll('img.lazy');
    images.forEach(img => {
        img.src = img.dataset.src;
    });
} else {
    const LazyLoad = require("vanilla-lazyload");
    global.lazyLoad = new LazyLoad();
}